import { SocialPost } from '@tytapp/common';

const USER_BRUNO = {
    display_name: 'Bruno Ricardo',
    avatar: 'https://avatars.dicebear.com/api/avataaars/tyt.svg',
    username: 'brunoricardo'
};

function sampleCommentPost(text: string, post: Partial<SocialPost> = {}): SocialPost {
    return {
        subject_type: 'Comment',
        date: (new Date()).toISOString(),
        likes_count: 0,
        comment_count: 0,
        repost_count: 0,
        is_highlighted: false,
        is_promoted: false,
        is_sponsored: false,
        is_pinned: false,
        hash_tags: [],
        comment: {
            attachments: [],
            text,
            user: {}
        },
        user: {
            display_name: 'Bruno Ricardo',
            avatar: 'https://avatars.dicebear.com/api/avataaars/tyt.svg',
            username: 'brunoricardo'
        },
        topics: [
            {
                name: 'Sample',
                description: 'This is a sample topic',
                slug: 'sample'
            }
        ],

        ...post
    }
}

export const SAMPLE_POSTS: SocialPost[] = [
    sampleCommentPost('This is a stock post'),
    sampleCommentPost('This is another stock post.'),
    sampleCommentPost(
        '',
        {
            comment_count: 1,
            information_leader_text: 'Recommended because you follow Foreign Policy',
            comment: {
                text: 'Hello World. I am <a href="#">@user_post</a>.<br>I am here to speak about <a href="#">#technology</a>',
                attachments: [
                    {
                        kind: 'image',
                        url: 'https://picsum.photos/700/400?random=1',
                    },
                    {
                        kind: 'image',
                        url: 'https://picsum.photos/700/400?random=2',
                    },
                    {
                        kind: 'image',
                        url: 'https://picsum.photos/700/400?random=3',
                    }
                ],
                user: {}
            },
            user: {
                display_name: 'Bruno Ricardo',
                avatar: 'https://avatars.dicebear.com/api/avataaars/tyt.svg',
                username: 'brunoricardo'
            },
            topics: [
                {
                    name: 'Sample',
                    description: 'This is a sample topic',
                    slug: 'sample'
                }
            ]
        }
    ),
    {
        subject_type: 'Petition',
        date: (new Date()).toISOString(),
        likes_count: 0,
        comment_count: 1,
        repost_count: 0,
        is_highlighted: false,
        is_promoted: false,
        is_sponsored: false,
        is_pinned: false,
        hash_tags: [],
        information_leader_text: 'Recommended because @cenk follows',
        petition: {
        },
        comment: {
            attachments: [
                {
                    kind: 'image',
                    url: 'https://picsum.photos/700/400?random=1',
                },
                {
                    kind: 'image',
                    url: 'https://picsum.photos/700/400?random=2',
                },
                {
                    kind: 'image',
                    url: 'https://picsum.photos/700/400?random=3',
                }
            ],
            text: 'Hello World. I am <a href="#">@user_post</a>.<br>I am here to speak about <a href="#">#technology</a> ',
            user: {}
        },
        user: {
            display_name: 'Bruno Ricardo',
            avatar: 'https://avatars.dicebear.com/api/avataaars/tyt.svg',
            username: 'brunoricardo'
        },
        topics: [
            {
                name: 'Sample',
                description: 'This is a sample topic',
                slug: 'sample'
            }
        ]
    }
];
